import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { map, Observable } from 'rxjs';
import {
  AntiTheftDto,
  ChangePinDto,
  OtherDeviceSettings,
  ParentalControlDto,
  ScreentimeDto,
  SendCommandDto,
  YoutubeControlDTO,
} from 'src/app/model/qModel.model';
import { ApiService } from 'src/app/services/api.service';
import { EncryptionService } from 'src/app/services/encryption.service';
import { CommonEnums } from 'src/app/utils/enum-utils';
import { compareVersions } from 'compare-versions';
import { translate } from '@angular/localize/src/utils';
declare let $: any;

interface DeviceControl {
  name: string;
  prop: 'smartParent' | 'screenTime' | 'YTSupervision' | 'Theft' | 'DPin';
  toggleTurnOnOffStatus: boolean;
}

@Component({
  selector: 'app-manage-device-control',
  templateUrl: './manage-device-control.component.html',
  styleUrls: ['./manage-device-control.component.scss'],
})

export class ManageDeviceControlComponent implements OnInit {
  deviceControlsList: DeviceControl[] = [
    {
      name: 'Smart Parenting',
      prop: 'smartParent',
      toggleTurnOnOffStatus: false,
    },
    { name: 'Screentime', prop: 'screenTime', toggleTurnOnOffStatus: false },
    {
      name: 'Youtube Supervision',
      prop: 'YTSupervision',
      toggleTurnOnOffStatus: false,
    },
    {
      name: 'Theft & Intrusion Alert',
      prop: 'Theft',
      toggleTurnOnOffStatus: false,
    },
    { name: 'Device Pin', prop: 'DPin', toggleTurnOnOffStatus: false },
  ];
  userId: any;
  deviceId: string = '';
  loggedInUser: any;
  selectedUserId: any;
  isLoading: boolean = false;
  openMyDeviceContent: boolean = false;
  deviceName: String;
  userName: String;
  userRole: String;
  currentUserName: String;
  currentUserRole: String;
  deviceLastSyncTime: String;
  screenTimeLastSyncTime: String;
  smartParentingLastSyncTime: String;
  ytSuperVisionLastSyncTime: String;
  antiTheftLastSyncTime: String;
  dPinSyncTime: String;
  bg_badge_clr: String = '#e3e7e9';
  txt_color: String = '#050505';
  toggleOff_bg_badge_clr: String = '#F1F1F1';
  toggleOn_bg_badge_clr: String = '#DBFFE4';
  toggleOff_txt_color: String = '#919191';
  toggleOn_txt_color: String = '#009A1F';
  toggleTurnOnOffStatus: Boolean = false;
  selectedI: number = 0;
  isScreenTimeOn: boolean = false;
  isSmartParentingOn: boolean = false;
  isYoutubeSuperVisionOn: boolean = false;
  isAntiTheftSettingsOn: boolean = false;
  isIntruderAlertOn: boolean = false;
  isAntiTheftAndIntrusionSettingOn: boolean = false;
  isDPinSettingOn: boolean = false;
  decryptedPin: any;
  isBlockedYTShorts: boolean = false;
  hours: number[] = Array.from({ length: 24 }, (_, i) => i); // [0, 1, 2, ..., 23]
  minutes: number[] = [0, 10, 20, 30, 40, 50, 59]; // [00, 10, 20, 30, 40, 50, 59]
  showScreenTimeWarning: boolean = false;
  selctedTabType:
    | 'smartParent'
    | 'screenTime'
    | 'YTSupervision'
    | 'Theft'
    | 'DPin' = 'smartParent';

  screentimeForm: FormGroup = new FormGroup({
    dailyScreenTimeHours: new FormControl('1'), // Default to 1 hour
    dailyScreenTimeMinutes: new FormControl('0'), // Default to 00 minutes
    dailyScreenTime: new FormControl(''),
    deviceId: new FormControl(''),
  });

  changePinForm: FormGroup = new FormGroup({
    deviceId: new FormControl(''),
    pin: new FormControl(''),
    confirmPin: new FormControl(''),
  });

  parentalControlForm: FormGroup = new FormGroup({
    systemId: new FormControl(''),
    user: new FormControl(''),
    featureStatus: new FormControl(),
    restrictWebCategoryList: new FormArray([]),
    excludedWebsiteList: new FormArray([]),
    restAppCategoryList: new FormArray([]),
    blockParticularWebsiteList: new FormArray([]),
    useCustomBrowser: new FormControl(false),
    allowedAppsList: new FormArray([]),
    restrictAppList: new FormArray([]),
    restrictCategoryList: new FormArray([]),
    webSecurityOn: new FormControl(false),
  });

  deviceForm: FormGroup = new FormGroup({
    deviceIds: new FormArray([]),
  });

  deviceFormFree: FormGroup = new FormGroup({
    deviceIds: new FormArray([]),
  });

  otherDeviceSettings: OtherDeviceSettings = new OtherDeviceSettings();
  privacyStatusBg: String = "#DEE9FE";
  privacyStatusClr: String = "#3F3F3F";
  otherDevices: any[] = [];
  otherDeviceFree: any[] = [];
  otherDevicePrem: any[] = [];
  selectedDevice: any[] = [];
  requestType: string = '';
  disableApply: boolean = false;
  sendCommanddto: SendCommandDto = new SendCommandDto();
  screentimeDto: ScreentimeDto = new ScreentimeDto();
  changepindto: ChangePinDto = new ChangePinDto();
  isLock: boolean = false;
  isSafeBrowsingTab = true;
  isAppLockTab = false;
  allAppChecked: boolean = false;
  preventAppInstallaion: boolean = false;
  safeBrowsingEnabled: boolean = false;
  webCatList = new Set();
  appCatList = new Set();
  individualAppChecked: boolean = false;

  allWebChecked: boolean = false;
  blockedAppList: any;
  excludedAppList: any;
  allowedAppList: any = [];
  restAppCategoryList: any = [];
  parentalControldto: ParentalControlDto = new ParentalControlDto();
  ytSupervisionDto: YoutubeControlDTO = new YoutubeControlDTO();
  antiTheftDto: AntiTheftDto = new AntiTheftDto();
  isSafeBrowsingOn: boolean = false;
  isDisabled: boolean = false;
  getParentalControlData: any;
  enJsonData: any;
  currentUserData: any;
  restrictCategoryList: any = [];
  websiteList: any[] = [];
  isLockOnTimeOut: boolean = false;
  isBlockOnAirplaneMode: boolean = false;
  antiTheftPrimaryNumberInput = '';
  antiTheftAlternateNumberInput = '';

  ytBlockedChannels: string[] = [];
  ytBlockedChannelInput = '';

  ytBlockedVideos: string[] = [];
  ytBlockedVideoInput = '';

  ytBlockedCategories: any[] = [];
  ytAllCategoriesChecked: boolean = false;

  ytBlockedKeywords: string[] = [];
  ytBlockedKeywordInput = '';

  ytAllowedChannels: string[] = [];
  ytAllowedChannelInput = '';

  ytAllowedVideos: string[] = [];
  ytAllowedVideoInput = '';

  ytBlockedVideoRecordExist: any;
  ytAllowedVideoRecordExist: any;
  ytBlockedChannelRecordExist: any;
  ytBlockedKeywordRecordExist: any;
  ytAllowedChannelRecordExist: any;

  confirmpin: boolean = false;
  password: any = CommonEnums.password;
  passwords: any = CommonEnums.password;
  pinNotMatch: boolean = false;
  disableSave: boolean = true;
  loginPin: boolean = false;

  primaryMobileError: string = '';
  alternateMobileError: string = '';
  sameNumberError: string = '';
  disableSaveButton: boolean = false;
  enDataJson: any;

  premiumRepInfo: any;
  status: any;
  licenseValidity: any;
  renewalLink: any;
  showPremium: boolean = false;
  productKey: any;
  productKeyType: any;
  mobileCompatibleVer: any;

  private isYtSupervisionDirty: boolean = false;
  private isAntiTheftDirty: boolean = false;
  private isParentalControlWebDirty: boolean = false;
  private isParentalControlAppDirty: boolean = false;
  private isScreenTimeDirty: boolean = false;
  selectedLanguage: string = '';

  private pendingTabIndex: number | null = null;
  private pendingTabType: 'smartParent' | 'screenTime' | 'YTSupervision' | 'Theft' | 'DPin' | null = null;

  constructor(
    private location: Location,
    private _actRout: ActivatedRoute,
    private _service: ApiService,
    private _toastr: ToastrService,
    private _formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef,
    private encryptService: EncryptionService,
    private translate: TranslateService,
    private _router: Router
  ) {
    // Initialize parentalControlForm in constructor
    this.parentalControlForm = this._formBuilder.group({
      systemId: [''],
      user: [''],
      featureStatus: [false],
      restrictWebCategoryList: this._formBuilder.array([]),
      excludedWebsiteList: this._formBuilder.array([]),
      restAppCategoryList: this._formBuilder.array([]),
      blockParticularWebsiteList: this._formBuilder.array([]),
      useCustomBrowser: [false],
      allowedAppsList: this._formBuilder.array([]),
      restrictAppList: this._formBuilder.array([]),
      restrictCategoryList: this._formBuilder.array([]),
      webSecurityOn: [false],
    });

    translate.addLangs(['en', 'fr', 'it', 'ja']);
    translate.setDefaultLang('en');
    translate.get(['DASHBOARD']).subscribe((values) => {
      this.enDataJson = Object.keys(values).map((key) => values[key]);
    });
    console.log()
  }

  ngOnInit(): void {
    let selectedLangStringValue = localStorage.getItem('selectedLang');
    if (selectedLangStringValue) {
      this.selectedLanguage = selectedLangStringValue;
      this.translate.use(this.selectedLanguage);
    }
    this.openMyDeviceContent = true;
    this.isSmartParentingOn = false;
    this.isScreenTimeOn = false;
    this.isYoutubeSuperVisionOn = false;
    this.safeBrowsingEnabled = false;
    let currentUser = localStorage.getItem('currentUser');

    if (currentUser) {
      this.loggedInUser = JSON.parse(currentUser);
      this.userName = this.loggedInUser.name;
      this.userRole = this.loggedInUser.roleTypeStr;
      this.userId = this.loggedInUser.id;
    }
    this.deviceId = this._actRout.snapshot.params['id'];
    this._actRout.queryParams.subscribe(params => {
      this.selectedUserId = params['userId'];
    });

    this.getDeviceDetailsById(this.deviceId);
    this.getScreenTimeDataByDeviceId(this.deviceId);
    this.getSmartParentingSetttingsByDeviceId(this.deviceId);
    this.getBlockYoutubeSettingsByDeviceId(this.deviceId);
    this.getDevicePinSettingsByDeviceId(this.deviceId);
    this.getDeviceAntiTheftSettingsByDeviceId(this.deviceId);
    this.getDeviceInUserTree();

    this.screentimeForm.valueChanges.subscribe((value) => {
      const hours = Number(value.dailyScreenTimeHours);
      const minutes = Number(value.dailyScreenTimeMinutes);
      const totalMinutes = hours * 60 + minutes;
      this.showScreenTimeWarning = totalMinutes > 240;
    });

    const myModalElement = document.getElementById('resetSettingsModal'); // Replace 'myModal' with your modal's ID

    if (myModalElement && myModalElement.classList.contains('show')) {
      $("#resetSettingsModal").modal("hide");
    }
    this.mobileCompatibleVer = (localStorage.getItem('MobileCompatibleVersion') || '').trim();
  }

  getScreenTimeDataByDeviceId(deviceId: String): void {
    this.isScreenTimeOn = false;
    this._service
      .getService(this._service.API_URL.getScreentime + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          if (response.data.isEnable === true) {
            const screenTimeItem = this.deviceControlsList.find(
              (item) => item.prop === 'screenTime'
            );
            if (screenTimeItem) {
              screenTimeItem.toggleTurnOnOffStatus = true;
            }
            this.isScreenTimeOn = true;
            // Convert total minutes to hours and minutes
            const totalMinutes = response.data.dailyScreenTime || 0;
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            // Find the closest valid minute value from the minutes array
            const closestMinute = this.minutes.reduce((prev, curr) =>
              Math.abs(curr - minutes) < Math.abs(prev - minutes) ? curr : prev
            );
            // Patch form values
            this.screentimeForm.patchValue({
              dailyScreenTimeHours:
                totalMinutes < 60 ? '0' : hours <= 23 ? hours : '1',
              dailyScreenTimeMinutes: closestMinute,
              dailyScreenTime: totalMinutes,
            });

            this.showScreenTimeWarning = totalMinutes > 240;
            // Enable form if screen time is on
            if (this.isScreenTimeOn) {
              this.screentimeForm.enable();
            }

            if (response.data.lockOnTimeOut != null) {
              if (response.data.lockOnTimeOut === true) {
                this.isLockOnTimeOut = true;
              } else {
                this.isLockOnTimeOut = false;
              }
            } else {
              this.isLockOnTimeOut = false;
            }
          } else {
            this.screentimeForm.disable();
            const screenTimeItem = this.deviceControlsList.find(
              (item) => item.prop === 'screenTime'
            );
            if (screenTimeItem) {
              screenTimeItem.toggleTurnOnOffStatus = false;
            }
            this.isScreenTimeOn = false;
            this.showScreenTimeWarning = false;
          }
          this.screenTimeLastSyncTime = response.data.lastUpdatedOnStr;
        } else {
          this.screentimeForm.disable();
          const screenTimeItem = this.deviceControlsList.find(
            (item) => item.prop === 'screenTime'
          );
          if (screenTimeItem) {
            screenTimeItem.toggleTurnOnOffStatus = false;
          }
          this.isScreenTimeOn = false;
          this.showScreenTimeWarning = false;
        }
      });
  }

  useCustomBrowser: boolean = false;

  getSmartParentingSetttingsByDeviceId(deviceId: String): void {
    this._service
      .getService(this._service.API_URL.getParentalControl + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          this.getParentalControlData = response.data;
          this.restrictCategoryList = response.data.restrictCategoryList;
          this.useCustomBrowser = response.data.useCustomBrowser;
          this.smartParentingLastSyncTime = response.data.lastUpdatedOnStr;
          this.blockParticularWebList =
            response.data.blockParticularWebsiteList;
          this.websiteList = response.data.excludedWebsiteList;

          this.parentalControlForm.patchValue({
            ...response.data,
          });
          const browserType = response.data.useCustomBrowser ? 'Standard' : 'custom';

          this.browserList(browserType);

          this.isDisabled = !this.useCustomBrowser;

          setTimeout(() => {
            this.parentalControlForm.markAsPristine();
          }, 300);

          this.mapJsonStringtoDto(response.data);

          if (this.isSmartParentingOn == false) {
            const parentalControlItem = this.deviceControlsList.find(
              (item) => item.prop === 'smartParent'
            );
            if (parentalControlItem) {
              parentalControlItem.toggleTurnOnOffStatus =
                response.data.parentalCntrl;
            }
            this.isSmartParentingOn = response.data.parentalCntrl;
          }

          if (!this.isParentalControlWebDirty) {
            this.safeBrowsingEnabled = response.data.webSecurityOn;
          }
        } else {
          const parentalControlItem = this.deviceControlsList.find(
            (item) => item.prop === 'smartParent'
          );
          if (parentalControlItem) {
            parentalControlItem.toggleTurnOnOffStatus = false;
          }
          this.isSmartParentingOn = false;
          this.mapJsonStringtoDto(response.data || {});
        }
      });
  }

  getBlockYoutubeSettingsByDeviceId(deviceId: String): void {
    this.isYoutubeSuperVisionOn = false;
    this._service
      .getService(this._service.API_URL.getBlockyoutube + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          this.ytSuperVisionLastSyncTime = response.data.lastUpdatedTime;
          const ytSuperVision = this.deviceControlsList.find(
            (item) => item.prop === 'YTSupervision'
          );
          if (ytSuperVision) {
            ytSuperVision.toggleTurnOnOffStatus = response.data.isEnable;
          }
          this.isBlockedYTShorts = response.data.blockShort;
          this.isYoutubeSuperVisionOn = response.data.isEnable;
          this.ytBlockedChannels = response.data.blockedChannels || [];
          this.ytBlockedVideos = response.data.blockedVideos || [];
          this.ytBlockedCategories = response.data.blockedCategories || [];
          this.ytAllCategoriesChecked =
            this.ytBlockedCategories.length > 0 &&
            this.ytBlockedCategories.every((cat) => cat.isChecked);
          this.ytBlockedKeywords = response.data.blockedKeywords || [];
          this.ytAllowedChannels = response.data.allowedChannels || [];
          this.ytAllowedVideos = response.data.allowedVideos || [];
        } else {
          const ytSuperVision = this.deviceControlsList.find(
            (item) => item.prop === 'YTSupervision'
          );
          if (ytSuperVision) {
            ytSuperVision.toggleTurnOnOffStatus = false;
          }
          this.isBlockedYTShorts = false;
          this.isYoutubeSuperVisionOn = false;
        }
      });
  }

  getDevicePinSettingsByDeviceId(deviceId: String): void {
    this._service
      .getService(this._service.API_URL.getChangePinById + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          this.dPinSyncTime = response.data.lastUpdatedTime;
          const dPinSettings = this.deviceControlsList.find(
            (item) => item.prop === 'DPin'
          );
          if (dPinSettings) {
            dPinSettings.toggleTurnOnOffStatus =
              response.data.isEnable == 'YES' ? true : false;
          }
          this.isDPinSettingOn = response.data.isEnable == 'YES' ? true : false;
          this.decryptedPin = this.encryptService.decrypt(response.data.pin);
        } else {
          const dPinSettings = this.deviceControlsList.find(
            (item) => item.prop === 'DPin'
          );
          if (dPinSettings) {
            dPinSettings.toggleTurnOnOffStatus = false;
          }
          this.isDPinSettingOn = false;
        }
      });
  }

  getDeviceAntiTheftSettingsByDeviceId(deviceId: String): void {
    this.isAntiTheftAndIntrusionSettingOn = false;
    this._service
      .getService(this._service.API_URL.getAntiTheft + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          this.isIntruderAlertOn = response.data.intruderAlertSettingsOn;
          this.isBlockOnAirplaneMode = response.data.blockOnAirPlaneMode;
          this.isAntiTheftSettingsOn = response.data.antiTheftSettingsOn;
          this.antiTheftLastSyncTime = response.data.lastUpdatedDate;
          if (response.data.primaryContactNumber != null) {
            this.antiTheftPrimaryNumberInput =
              response.data.primaryContactNumber;
          }

          if (response.data.secondaryContactNumber != null) {
            this.antiTheftAlternateNumberInput =
              response.data.secondaryContactNumber;
          }

          if (response.data.antiTheftSettingsOn) {
            this.isAntiTheftAndIntrusionSettingOn = true;
            if (this.antiTheftPrimaryNumberInput === '') {
              this.primaryMobileError = this.translate.instant(
                'SETTINGS.PRIMARYNUMBERREQUIRED'
              );
              this.disableSaveButton = true;
            }

            if (this.antiTheftPrimaryNumberInput.length > 0 && this.antiTheftPrimaryNumberInput.length !== 10) {
              this.primaryMobileError = this.translate.instant(
                'SETTINGS.PRIMARYNUMBER10DIGITWARNING'
              );
              this.disableSaveButton = true;
            }

            if (this.antiTheftAlternateNumberInput.length > 0 && this.antiTheftAlternateNumberInput.length !== 10) {
              this.alternateMobileError = this.translate.instant(
                'SETTINGS.ALTERNATENUMBER10DIGITWARNING'
              );
              this.disableSaveButton = true;
            }
          }

          if (response.data.intruderAlertSettingsOn) {
            this.isAntiTheftAndIntrusionSettingOn = true;
          }

          const antiTheftAndIntrudSettingsToggle =
            this.deviceControlsList.find((item) => item.prop === 'Theft');
          if (antiTheftAndIntrudSettingsToggle) {
            antiTheftAndIntrudSettingsToggle.toggleTurnOnOffStatus = this.isAntiTheftAndIntrusionSettingOn;
          }

        } else {
          this.isIntruderAlertOn = response.data.intruderAlertSettingsOn;
          this.isBlockOnAirplaneMode = response.data.blockOnAirPlaneMode;
          this.isAntiTheftSettingsOn = response.data.antiTheftSettingsOn;
          this.isAntiTheftAndIntrusionSettingOn = false;

          const antiTheftAndIntrudSettingsToggle = this.deviceControlsList.find(
            (item) => item.prop === 'Theft'
          );
          if (antiTheftAndIntrudSettingsToggle) {
            antiTheftAndIntrudSettingsToggle.toggleTurnOnOffStatus = false;
          }
        }
      });
  }

  getDeviceDetailsById(deviceId: String): void {
    this._service
      .getService(this._service.API_URL.getDeviceDetailsById + deviceId)
      .subscribe((response: any) => {
        if (response && response.data && response.status.code === 200) {
          this.premiumRepInfo = [response.data];
          this.checkPremiumFeature(deviceId);
          this.deviceName = response.data.deviceName;
          this.deviceLastSyncTime = response.data.lastSyncDateStr;
          this.currentUserName = response.data.currentUserName;
          this.currentUserRole = response.data.userRole;
        }
      });
  }

  goBack() {
    if (this.hasUnsavedChanges()) {
      // Show the back unsaved changes modal
      $('#BackUnsavedSettingsPopup').modal('show');
    } else {
      // this.location.back();
      this._router.navigate(['/home/manage-device'], {
        queryParams: {
          userId: this.selectedUserId, // Assuming selectedUserId is stored in manage-device-control
          deviceId: this.deviceId, // Assuming deviceId is the ID of the current device
        },
      });
    }
  }

  getCurrentIndex: number = 0;

  selectedIndex(i: number, data: DeviceControl) {
    if (this.hasUnsavedChanges()) {
      // Store the target tab
      this.pendingTabIndex = i;
      this.pendingTabType = data.prop; // Type-safe due to DeviceControl interface
      // Show the unsaved changes modal
      $('#UnsavedSettingsPopup').modal('show');
    } else {
      // Proceed with tab switch
      this.getCurrentIndex = i;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.selectedI = i;
      this.selctedTabType = data.prop;
      this.handleTabSwitch(data.prop);
    }
  }

  private handleTabSwitch(tabType: 'smartParent' | 'screenTime' | 'YTSupervision' | 'Theft' | 'DPin') {
    if (tabType === 'screenTime') {
      this.isSmartParentingOn = false;
      this.getScreenTimeDataByDeviceId(this.deviceId);
    } else if (tabType === 'smartParent') {
      this.isScreenTimeOn = false;
      this.isAppLockTab = false;
      this.isSafeBrowsingTab = true;
      this.checkPremiumFeature(this.deviceId);
      this.getSmartParentingSetttingsByDeviceId(this.deviceId);
    } else if (tabType === 'YTSupervision') {
      this.isYoutubeSuperVisionOn = false;
      this.getBlockYoutubeSettingsByDeviceId(this.deviceId);
    } else if (tabType === 'DPin') {
      this.isDPinSettingOn = false;
      this.changePinForm.controls['pin'].setValue('');
      this.changePinForm.controls['confirmPin'].setValue('');
      this.pinNotMatch = false;
      this.getDevicePinSettingsByDeviceId(this.deviceId);
    } else if (tabType === 'Theft') {
      this.isAntiTheftAndIntrusionSettingOn = false;
      this.getDeviceAntiTheftSettingsByDeviceId(this.deviceId);
    }
  }

  onChangeScreenToggle(event: Event) {
    //this.screentimeForm.markAsDirty();
    if (this.isScreenTimeOn) {
      this.screentimeForm.enable();
      const screenTimeItem = this.deviceControlsList.find(
        (item) => item.prop === 'screenTime'
      );
      if (screenTimeItem) {
        screenTimeItem.toggleTurnOnOffStatus = this.isScreenTimeOn;
      }
      // Check if current hours value warrants showing the warning
      const hours = Number(
        this.screentimeForm.get('dailyScreenTimeHours')?.value
      );
      const minutes = Number(
        this.screentimeForm.get('dailyScreenTimeMinutes')?.value
      );
      const totalMinutes = hours * 60 + minutes;
      this.showScreenTimeWarning = totalMinutes > 240;
    } else {
      this.screentimeForm.disable();
      const screenTimeItem = this.deviceControlsList.find(
        (item) => item.prop === 'screenTime'
      );
      if (screenTimeItem) {
        screenTimeItem.toggleTurnOnOffStatus = false;
      }
      this.showScreenTimeWarning = false;
    }
    this.screentimeForm.markAsDirty;
    this.isScreenTimeDirty = true;
  }

  onChangeLockOnTimeOut(event: Event) {
    this.isScreenTimeDirty = true;
  }

  onChangeSmartParentingToggle(event: Event) {
    const parentalControlItem = this.deviceControlsList.find(
      (item) => item.prop === 'smartParent'
    );
    if (parentalControlItem) {
      parentalControlItem.toggleTurnOnOffStatus = this.isSmartParentingOn;
    }
    this.isParentalControlWebDirty = true;
  }

  onChangeYoutubeSuperVisionToggle(event: Event) {
    const YTSupervision = this.deviceControlsList.find(
      (item) => item.prop === 'YTSupervision'
    );
    if (YTSupervision) {
      YTSupervision.toggleTurnOnOffStatus = this.isYoutubeSuperVisionOn;
    }
    this.isYtSupervisionDirty = true;
  }

  onChangeAntitheftSettingsToggle(event: Event) {
    if (!this.isAntiTheftSettingsOn) {
      this.disableSaveButton = false;
      this.primaryMobileError = '';
      this.alternateMobileError = '';
      if (!this.isIntruderAlertOn) {
        this.isAntiTheftAndIntrusionSettingOn = false;
      }
    } else {
      if (this.alternateMobileError != '' || this.sameNumberError != '' || this.primaryMobileError != '') {
        this.disableSaveButton = true;
      }

      if (this.antiTheftPrimaryNumberInput === '') {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBERREQUIRED'
        );
        this.disableSaveButton = true;
      }

      if (this.antiTheftPrimaryNumberInput.length > 0 && this.antiTheftPrimaryNumberInput.length !== 10) {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }

      if (this.antiTheftAlternateNumberInput.length > 0 && this.antiTheftAlternateNumberInput.length !== 10) {
        this.alternateMobileError = this.translate.instant(
          'SETTINGS.ALTERNATENUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }
    }
    this.isAntiTheftDirty = true
  }

  onChangeBlockOnAirplaneMode(event: Event) {
    this.isAntiTheftDirty = true;
  }

  onChangeIntruderAlertSettingsToggle(event: Event) {
    if (!this.isIntruderAlertOn) {
      if (!this.isAntiTheftSettingsOn) {
        this.isAntiTheftAndIntrusionSettingOn = false;
      }
    }
    this.isAntiTheftDirty = true
  }

  onChangeAntitheftAndIntrusionSettingsToggle(event: Event) {
    const antiTheftSettingControl = this.deviceControlsList.find(
      (item) => item.prop === 'Theft'
    );
    if (antiTheftSettingControl) {
      antiTheftSettingControl.toggleTurnOnOffStatus =
        this.isAntiTheftAndIntrusionSettingOn;
    }

    if (!this.isAntiTheftAndIntrusionSettingOn) {
      this.disableSaveButton = false;
      this.primaryMobileError = '';
      this.alternateMobileError = '';
    } else {
      if (this.alternateMobileError != '' || this.sameNumberError != '' || this.primaryMobileError != '') {
        this.disableSaveButton = true;
      }

      if (this.antiTheftPrimaryNumberInput === '') {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBERREQUIRED'
        );
        this.disableSaveButton = true;
      }

      if (this.antiTheftPrimaryNumberInput.length > 0 && this.antiTheftPrimaryNumberInput.length !== 10) {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }

      if (this.antiTheftAlternateNumberInput.length > 0 && this.antiTheftAlternateNumberInput.length !== 10) {
        this.alternateMobileError = this.translate.instant(
          'SETTINGS.ALTERNATENUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }
    }

    this.isAntiTheftSettingsOn = this.isAntiTheftAndIntrusionSettingOn;
    this.isIntruderAlertOn = this.isAntiTheftAndIntrusionSettingOn;
    this.isAntiTheftDirty = true
  }

  onChangeDpinSettingsToggle(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!this.isDPinSettingOn && !input.checked) {
      // Revert the toggle state to true
      input.checked = true;
      this.isDPinSettingOn = true;

      // Show a warning message
      this._toastr.warning(
        this.translate.instant('SETTINGS.DEVICEPINCANNOTTURNOFFVALIDATION')
      );
    }
    const dPinSettings = this.deviceControlsList.find(
      (item) => item.prop === 'DPin'
    );
    if (dPinSettings) {
      dPinSettings.toggleTurnOnOffStatus = this.isDPinSettingOn;
    }
    this.changePinForm.markAsDirty;
  }

  onChangeBlockYTShortsToggle(event: Event) {
    this.isYtSupervisionDirty = true;
  }

  saveScreenTimeSettings(): void {
    if (this.isAntiTheftSettingsOn && this.selctedTabType == 'Theft' && (this.antiTheftPrimaryNumberInput == null || this.antiTheftPrimaryNumberInput == '')) {
      this.primaryMobileError = this.translate.instant(
        'SETTINGS.PRIMARYNUMBERBLANKWARNING'
      );
      this.disableSaveButton = true;
    } else {
      if (this.selctedTabType == 'smartParent') {
        this.saveParentalControlSettingsObservable(false).subscribe({
          next: (result) => { },
          error: () => {
            this.isLoading = false;
          },
        });
      }
      if (this.selctedTabType == 'screenTime') {
        this.saveScreenTimeSettingsObservable(false).subscribe({
          next: (result) => { },
          error: () => {
            this.isLoading = false;
          },
        });
      }

      if (this.selctedTabType == 'YTSupervision') {
        this.saveYoutubeSupervisionSettingsObservable(false).subscribe({
          next: (result) => { },
          error: () => {
            this.isLoading = false;
          },
        });
      }

      if (this.selctedTabType == 'DPin') {
        this.submitChangePin(true).subscribe({
          next: (result) => {
            if (result === 200) {
              this.sendCommanddto.deviceId = this.deviceId;
              this.sendCommanddto.requestType = 'PIN_SETTING';
              this.sendCommanddto.productKeyType = 'MOBILE';
              this._service
                .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
                .subscribe({
                  next: (response) => {
                    if (response && response.status.code === 200) {
                      this.isLoading = false;
                      this.isLock = false;
                      this._toastr.success(
                        this.translate.instant("TOSTRMSGS.QH_TOSTR_DPINSETTINGCMNDINIT")
                      );
                    } else {
                      this._toastr.error('', response.status.message);
                      this.isLoading = false;
                    }
                  },
                  error: () => {
                    this.isLoading = false;
                  },
                });
            } else {
              this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_DEVICE_PIN_SETTING'));
              this.isLoading = false;
            }
          },
          error: () => {
            this.isLoading = false;
          },
        });
      }

      if (this.selctedTabType == 'Theft') {
        this.saveAntiTheftSettingsObservable(false).subscribe({
          next: (result) => { },
          error: () => {
            this.isLoading = false;
          },
        });
      }
    }
  }

  sendCommand(): void {

    if (this.isAntiTheftSettingsOn && this.selctedTabType == 'Theft' && (this.antiTheftPrimaryNumberInput == null || this.antiTheftPrimaryNumberInput == '')) {
      this.primaryMobileError = this.translate.instant(
        'SETTINGS.PRIMARYNUMBERBLANKWARNING'
      );
      this.disableSaveButton = true;
    } else {
      if (this.selctedTabType == 'screenTime') {
        this.sendScreenTimeCommand();
      }
      if (this.selctedTabType == 'smartParent') {
        this.sendParentalControlCommand();
      }

      if (this.selctedTabType == 'YTSupervision') {
        this.sendYoutubeSupervisionCommand();
      }

      if (this.selctedTabType == 'DPin') {
        this.sendDevicePinSettingsCommand();
      }

      if (this.selctedTabType == 'Theft') {
        this.sendAntiTheftCommand();
      }
    }
  }

  saveScreenTimeSettingsObservable(
    isApplySettings: boolean
  ): Observable<number> {
    this.isLoading = true;
    const hours = Number(
      this.screentimeForm.get('dailyScreenTimeHours')?.value
    );
    const minutes = Number(
      this.screentimeForm.get('dailyScreenTimeMinutes')?.value
    );
    const totaltimeinminutes = hours * 60 + minutes;
    this.screentimeDto.dailyScreenTime = totaltimeinminutes;
    this.screentimeDto.deviceId = this.deviceId;
    this.screentimeDto.isEnable = this.isScreenTimeOn;
    this.screentimeDto.lockOnTimeOut = this.isLockOnTimeOut;

    return this._service
      .postService(this._service.API_URL.saveScreentime, this.screentimeDto)
      .pipe(
        map((response) => {
          this.isLoading = false;
          if (response && response.status.code === 200) {
            this.isLock = false;
            this.isScreenTimeDirty = false;
            this.screentimeForm.markAsPristine;
            this.screentimeForm.reset();
            if (!isApplySettings) {
              this._toastr.success(
                this.translate.instant("TOSTRMSGS.QH_TOSTR_ST")
              );
            }

            if (response.data.isEnable === true) {
              const screenTimeItem = this.deviceControlsList.find(
                (item) => item.prop === 'screenTime'
              );
              if (screenTimeItem) {
                screenTimeItem.toggleTurnOnOffStatus = true;
              }
              this.isScreenTimeOn = true;
              // Convert total minutes to hours and minutes
              const totalMinutes = response.data.dailyScreenTime || 0;
              const hours = Math.floor(totalMinutes / 60);
              const minutes = totalMinutes % 60;
              // Find the closest valid minute value from the minutes array
              const closestMinute = this.minutes.reduce((prev, curr) =>
                Math.abs(curr - minutes) < Math.abs(prev - minutes)
                  ? curr
                  : prev
              );
              // Patch form values
              this.screentimeForm.patchValue({
                dailyScreenTimeHours:
                  totalMinutes < 60 ? '0' : hours <= 23 ? hours : '1',
                dailyScreenTimeMinutes: closestMinute,
                dailyScreenTime: totalMinutes,
              });

              this.showScreenTimeWarning = totalMinutes > 240;
              // Enable form if screen time is on
              if (this.isScreenTimeOn) {
                this.screentimeForm.enable();
              }

              if (response.data.lockOnTimeOut != null) {
                if (response.data.lockOnTimeOut === true) {
                  this.isLockOnTimeOut = true;
                } else {
                  this.isLockOnTimeOut = false;
                }
              } else {
                this.isLockOnTimeOut = false;
              }
            } else {
              this.screentimeForm.disable();
              const screenTimeItem = this.deviceControlsList.find(
                (item) => item.prop === 'screenTime'
              );
              if (screenTimeItem) {
                screenTimeItem.toggleTurnOnOffStatus = false;
              }
              this.isScreenTimeOn = false;
              this.showScreenTimeWarning = false;
            }
            this.screenTimeLastSyncTime = response.data.lastUpdatedOnStr;
            return response.status.code;
          } else {
            this._toastr.error('', response.status.message);
            this.getScreenTimeDataByDeviceId(this.deviceId);
            throw new Error(response.status.message);
          }
        })
      );
  }

  updateToggleChangeEvent(event: any, type: any) {
    if (type === 'PARENTAL_CONTROL' || type === 'YOUTUBE_SETTING') {
      this.toggleOn = event;
    } else {
      this.toggleOn = event.target.checked;
    }
    this.controlType = type;
    this.updateToggle();
  }

  toggleOn: boolean = false;
  controlType: any;
  updateToggle() {
    let data = {
      toggleOn: this.toggleOn,
      deviceId: this.deviceId,
      settingType: this.controlType,
    };
    this._service
      .putService(this._service.API_URL.updateToggle, data)
      .subscribe((response) => {
        if (response && response.status.code === 200) {
          this.parentalControlForm.markAsPristine();
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message);
        }
      });
  }

  saveParentalControlSettingsObservable(
    isApplySettings: boolean
  ): Observable<number> {
    this.isLoading = true;
    this.restAppCategoryList =
      this.parentalControlForm.value.restAppCategoryList;
    this.restrictCategoryList =
      this.parentalControlForm.value.restrictCategoryList;
    this.parentalControldto = this.parentalControlForm.value;
    this.parentalControldto.preventAppInstallaion = this.preventAppInstallaion;
    this.parentalControldto.deviceId = this.deviceId;
    this.parentalControldto.parentalCntrl = this.isSmartParentingOn;
    this.parentalControldto.blockParticularWebsiteList =
      this.blockParticularWebList;
    this.parentalControldto.blockAppCategoryList = this.restAppCategoryList;
    this.parentalControldto.excludedWebsiteList = this.websiteList;
    this.parentalControldto.webSecurityOn = this.safeBrowsingEnabled;


    this.parentalControldto.useCustomBrowser = this.useCustomBrowser;
    this.parentalControldto.allowedAppsList = this.allowedAppList;
    this.parentalControldto.restrictCategoryList = this.restrictCategoryList;
    if (this.status != null) {
      this.parentalControldto.licenseStatus = this.status;
    } else {
      this.parentalControldto.licenseStatus = this.licenseValidity;
    }


    return this._service
      .postService(
        this._service.API_URL.saveParentalControl,
        this.parentalControldto
      )
      .pipe(
        map((response) => {
          this.isLoading = false;
          if (response && response.status.code === 200) {
            this.isLock = false;
            this.parentalControlForm.markAsPristine();
            this.isParentalControlAppDirty = false;
            this.isParentalControlWebDirty = false;
            if (!isApplySettings) {
              this._toastr.success(
                this.translate.instant("TOSTRMSGS.QH_TOSTR_SP")
              );
            }
            setTimeout(() => {
              this.parentalControlForm.markAsPristine();
            }, 0);
            this.getSmartParentingSetttingsByDeviceId(this.deviceId);
            return response.status.code;
          } else {
            this._toastr.error('', response.status.message);
            this.isSmartParentingOn = false;
            this.getSmartParentingSetttingsByDeviceId(this.deviceId);
            throw new Error(response.status.message);
          }
        })
      );
  }

  saveYoutubeSupervisionSettingsObservable(
    isApplySettings: boolean
  ): Observable<number> {
    this.isLoading = true;
    this.updateToggleChangeEvent(this.toggleOn, 'YOUTUBE_SETTING');

    this.ytSupervisionDto.deviceId = this.deviceId;
    this.ytSupervisionDto.isEnable = this.isYoutubeSuperVisionOn;
    this.ytSupervisionDto.blockShort = this.isBlockedYTShorts;
    this.ytSupervisionDto.blockedChannels = this.ytBlockedChannels;
    this.ytSupervisionDto.blockedVideos = this.ytBlockedVideos;
    this.ytSupervisionDto.blockedCategories = this.ytBlockedCategories;
    this.ytSupervisionDto.blockedKeywords = this.ytBlockedKeywords;
    this.ytSupervisionDto.allowedChannels = this.ytAllowedChannels;
    this.ytSupervisionDto.allowedVideos = this.ytAllowedVideos;

    return this._service
      .postService(
        this._service.API_URL.saveYoutubeSuperVision,
        this.ytSupervisionDto
      )
      .pipe(
        map((response) => {
          this.isLoading = false;
          if (response && response.status.code === 200) {
            this.isYtSupervisionDirty = false;
            this.isLock = false;
            this.parentalControlForm.markAsPristine();
            if (!isApplySettings) {
              this._toastr.success(
                this.translate.instant("TOSTRMSGS.QH_TOSTR_YTS")
              );
            }
            setTimeout(() => {
              this.parentalControlForm.markAsPristine();
            }, 0);
            this.getBlockYoutubeSettingsByDeviceId(this.deviceId);
            this.isLoading = false;
            return response.status.code;
          } else {
            this._toastr.error('', response.status.message);
            this.getBlockYoutubeSettingsByDeviceId(this.deviceId);
            throw new Error(response.status.message);
          }
        })
      );
  }

  saveAntiTheftSettingsObservable(
    isApplySettings: boolean
  ): Observable<number> {
    this.isLoading = true;
    this.antiTheftDto.deviceId = this.deviceId;
    this.antiTheftDto.antiTheftSettingsOn = this.isAntiTheftSettingsOn;
    if (this.isAntiTheftSettingsOn) {
      this.antiTheftDto.blockOnAirPlaneMode = this.isBlockOnAirplaneMode;
      this.antiTheftDto.primaryContactNumber = this.antiTheftPrimaryNumberInput;
      this.antiTheftDto.secondaryContactNumber =
        this.antiTheftAlternateNumberInput;
    }
    if (this.showPremium) {
      this.antiTheftDto.intruderAlertSettingsOn = false;
    } else {
      this.antiTheftDto.intruderAlertSettingsOn = this.isIntruderAlertOn;
    }


    return this._service
      .postService(this._service.API_URL.saveAntiTheft, this.antiTheftDto)
      .pipe(
        map((response) => {
          this.isLoading = false;
          if (response && response.status.code === 200) {
            this.isLock = false;
            this.isAntiTheftDirty = false;
            if (!isApplySettings) {
              this._toastr.success(
                this.translate.instant("TOSTRMSGS.QH_TOSTR_AT")
              );
            }
            this.getDeviceAntiTheftSettingsByDeviceId(this.deviceId);
            this.isLoading = false;
            return response.status.code;
          } else {
            this._toastr.error('', response.status.message);
            this.getDeviceAntiTheftSettingsByDeviceId(this.deviceId);
            throw new Error(response.status.message);

          }
        })
      );
  }

  sendScreenTimeCommand(): void {
    this.isLoading = true;
    this.saveScreenTimeSettingsObservable(true).subscribe({
      next: (result) => {
        if (result === 200) {
          this.sendCommanddto.deviceId = this.deviceId;
          this.sendCommanddto.requestType = 'SCREEN_TIME_SETTING';
          this.sendCommanddto.productKeyType = 'MOBILE';
          this._service
            .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
            .subscribe({
              next: (response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.isLock = false;
                  this._toastr.success(this.translate.instant('TOSTRMSGS.QH_TOSTR_SCREENTIME_COMMAND'));
                  if (this.otherDeviceFree.length > 0) {
                    this.requestType = 'SCREEN_TIME_SETTING';
                    this.openupdatePopup()
                  }
                } else {
                  this._toastr.error('', response.status.message);
                  this.isLoading = false;
                }
              },
              error: () => {
                this.isLoading = false;
              },
            });
        } else {
          this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_SCREEN_TIME_SETTING'));
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  sendYoutubeSupervisionCommand(): void {
    this.isLoading = true;
    this.saveYoutubeSupervisionSettingsObservable(true).subscribe({
      next: (result) => {
        if (result === 200) {
          this.sendCommanddto.deviceId = this.deviceId;
          this.sendCommanddto.requestType = 'YOUTUBE_SUPERVISION_SETTING';
          this.sendCommanddto.productKeyType = 'MOBILE';
          this._service
            .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
            .subscribe({
              next: (response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.isLock = false;
                  this._toastr.success(
                    this.translate.instant("TOSTRMSGS.QH_TOSTR_YTS_COMMAND")
                  );
                  if (this.otherDevicePrem.length > 0) {
                    this.requestType = 'YOUTUBE_SUPERVISION_SETTING';
                    this.openupdatePopup()
                  }
                } else {
                  this._toastr.error('', response.status.message);
                  this.isLoading = false;
                }
              },
              error: () => {
                this.isLoading = false;
              },
            });
        } else {
          this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_YOUTUBE_SETTING'));
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  sendAntiTheftCommand(): void {
    this.isLoading = true;
    this.saveAntiTheftSettingsObservable(true).subscribe({
      next: (result) => {
        if (result === 200) {
          this.sendCommanddto.deviceId = this.deviceId;
          this.sendCommanddto.requestType = 'ANTITHEFT_SETTING';
          this.sendCommanddto.productKeyType = 'MOBILE';
          this._service
            .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
            .subscribe({
              next: (response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.isLock = false;
                  this._toastr.success(
                    this.translate.instant("TOSTRMSGS.QH_TOSTR_ANTI_THEFT")
                  );
                  if (this.otherDevicePrem.length > 0) {
                    this.requestType = 'ANTITHEFT_SETTING';
                    this.openupdatePopup()
                  }
                } else {
                  this._toastr.error('', response.status.message);
                  this.isLoading = false;
                }
              },
              error: () => {
                this.isLoading = false;
              },
            });
        } else {
          this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_ANTITHEFT_SETTING'));
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  sendDevicePinSettingsCommand(): void {
    this.isLoading = true;
    this.submitChangePin(true).subscribe({
      next: (result) => {
        if (result === 200) {
          this.sendCommanddto.deviceId = this.deviceId;
          this.sendCommanddto.requestType = 'PIN_SETTING';
          this.sendCommanddto.productKeyType = 'MOBILE';
          this._service
            .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
            .subscribe({
              next: (response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.isLock = false;
                  this._toastr.success('', this.translate.instant('TOSTRMSGS.QH_TOSTR_DPINSETTINGCMNDINIT'));
                  if (this.otherDeviceFree.length > 0) {
                    this.requestType = 'PIN_SETTING';
                    this.openupdatePopup()
                  }
                } else {
                  this._toastr.error('', response.status.message);
                  this.isLoading = false;
                }
              },
              error: () => {
                this.isLoading = false;
              },
            });
        } else {
          this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_DEVICE_PIN_SETTING'));
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  sendParentalControlCommand(): void {
    this.isLoading = true;
    this.saveParentalControlSettingsObservable(true).subscribe({
      next: (result) => {
        if (result === 200) {
          this.sendCommanddto.deviceId = this.deviceId;
          this.sendCommanddto.requestType = 'SMART_PARENTING_SETTING';
          this.sendCommanddto.productKeyType = 'MOBILE';
          this._service
            .postService(this._service.API_URL.sendCommand, this.sendCommanddto)
            .subscribe({
              next: (response) => {
                if (response && response.status.code === 200) {
                  this.isLoading = false;
                  this.isLock = false;
                  this._toastr.success(this.translate.instant('TOSTRMSGS.QH_TOSTR_SMART_PARENTING_COMMAND'));
                  if (this.otherDevicePrem.length > 0) {
                    this.requestType = 'SMART_PARENTING_SETTING';
                    this.openupdatePopup();
                  }
                } else {
                  this._toastr.error('', response.status.message);
                  this.isLoading = false;
                }
              },
              error: () => {
                this.isLoading = false;
              },
            });
        } else {
          this._toastr.error('', this.translate.instant('TOSTRMSGS.QH_TOSTR_SMARTPARENTING_SETTING'));
          this.isLoading = false;
        }
      },
      error: () => {
        this.isLoading = false;
      },
    });
  }

  openTabs(tabName: string) {
    if (tabName === 'SAFEBROWSING') {
      this.isSafeBrowsingTab = true;
      this.isAppLockTab = false;
      this.getSmartParentingSetttingsByDeviceId(this.deviceId);
    } else {
      this.isAppLockTab = true;
      this.isSafeBrowsingTab = false;
      this.getSmartParentingSetttingsByDeviceId(this.deviceId);
    }
  }

  // Getter for restAppCategoryList FormArray
  get restrictAppCategoryArray(): FormArray {
    return this.parentalControlForm.get('restAppCategoryList') as FormArray;
  }

  onBlockApplicationClick(event: any, data: any, type: string) {
    const isChecked = event.target.checked;
    //this.saveBtnDisable = false;
    if (type == 'single') {
      // Update the specific FormGroup in the FormArray
      const index = this.restrictAppCategoryArray.controls.findIndex(
        (control) => control.value.key === data.value.key
      );
      if (index !== -1) {
        this.restrictAppCategoryArray.at(index).patchValue({ isChecked });
        this.appCatList[isChecked ? 'add' : 'delete'](data.value.id);
        this.individualAppChecked = this.appCatList.size > 0;
        this.allAppChecked = this.restrictAppCategoryArray.controls.every(
          (control) => control.value.isChecked
        );
      }
    } else {
      this.restrictAppCategoryArray.controls.forEach((control) => {
        control.patchValue({ isChecked });
        this.appCatList[isChecked ? 'add' : 'delete'](control.value.id);
      });
      this.allAppChecked = isChecked;
      this.individualAppChecked = isChecked;
    }
    this.parentalControlForm.markAsDirty();
  }

  onBlockPlayStoreClick(event: any) {
    this.preventAppInstallaion = event.target.checked;
    this.isParentalControlAppDirty = true
  }

  onSafeBrowserToggle(event: any) {
    this.safeBrowsingEnabled = event.target.checked;
    this.isParentalControlWebDirty = true;
  }

  get getRestrictCategoryList(): FormArray {
    return this.parentalControlForm.get('restrictCategoryList') as FormArray;
  }

  mapJsonStringtoDto(data: any) {
    const appFormArray = this.parentalControlForm.get(
      'restAppCategoryList'
    ) as FormArray;
    appFormArray.clear();

    // Populate restAppCategoryList from blockAppCategoryList
    const appCategories = data.blockAppCategoryList || [];
    appCategories.forEach((item: any) => {
      appFormArray.push(
        this._formBuilder.group({
          key: [item.key],
          id: [item.id],
          value: [item.value],
          isChecked: [item.isChecked],
        })
      );
    });

    const restrictedAppFormArray = this.parentalControlForm.get(
      'restrictCategoryList'
    ) as FormArray;
    restrictedAppFormArray.clear();

    const restrictedAppCategories = data.restrictCategoryList || [];
    restrictedAppCategories.forEach((item: any) => {
      restrictedAppFormArray.push(
        this._formBuilder.group({
          key: [item.key],
          id: [item.id],
          value: [item.value],
          isChecked: [item.isChecked],
        })
      );
    });

    // Update blocked and excluded app lists
    this.blockedAppList = data.blockApplications || [];
    this.excludedAppList = data.excludeApplications || [];
    this.allowedAppList = data.allowedAppsList || [];
    this.restrictCategoryList = data.restrictCategoryList || [];
    this.cdr.detectChanges();
  }

  browserList(web: string) {
    this.isDisabled = web == 'Standard';
    this.useCustomBrowser = web !== 'custom';
  }


  deviceIdList = new Set();
  individualChecked: boolean = false;
  allChecked: boolean = false;
  //  Fetching the Device Id here and Passing the data to the TransferOwnership for Transfer Ownership
  onDeviceClickrestrict(event: any, data: any, type: string) {
    data.isChecked = event.target.checked;
    if (type == 'single') {
      if (event.target.checked && this.allChecked) {
        this.deviceIdList.add(data.id);
      } else {
        this.allChecked = false;
        this.deviceIdList.delete(data.id);
        this.individualChecked = this.deviceIdList.size > 0;
      }
      this.parentalControlForm.markAsDirty();
      this.allChecked = true;
      let restrictCategoryList: any[] = this.parentalControlForm.get(
        'restrictCategoryList'
      )?.value;
      restrictCategoryList.forEach((i) => {
        if (!i.isChecked) {
          this.allChecked = false;
        }
      });
    } else {
      if (event.target.checked) {
        // For Restrict Category List
        let restrictCategoryList: any[] = this.parentalControlForm.get(
          'restrictCategoryList'
        )?.value;
        restrictCategoryList.forEach((i) => (i.isChecked = true));
        this.parentalControlForm.controls['restrictCategoryList'].setValue(
          restrictCategoryList
        );

        this.parentalControlForm.updateValueAndValidity();
        data.forEach((element: any) => {
          this.allChecked = true;
          this.individualChecked = true;
          this.deviceIdList.add(element.id);
        });
      } else {
        // For Restrict Category List
        let restrictCategoryList: any[] = this.parentalControlForm.get(
          'restrictCategoryList'
        )?.value;
        restrictCategoryList.forEach((i) => (i.isChecked = false));
        this.parentalControlForm.controls['restrictCategoryList'].setValue(
          restrictCategoryList
        );

        this.parentalControlForm.updateValueAndValidity();
        data.forEach((element: any) => {
          this.individualChecked = false;
          this.allChecked = false;
          this.deviceIdList.delete(element.id);
        });
      }
      this.parentalControlForm.markAsDirty();
    }
  }

  blockParticularWebList: any;
  recordExist: any;
  recordExistForExcludedWebsite: any;
  blockSite: any;
  blockParticluarWebsiteSiteUrl() {
    this.recordExist = null;
    const regex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^\s]*)?$/;
    if (!regex.test(this.blockSite)) {
      this._toastr.error(
        this.translate.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL")
      );
      return false;
    } else {
      this.recordExist = null;
      const webData = this.blockParticularWebList.find((x: any) => x === this.blockSite);
      const allowedWebData = this.websiteList.find((x: any) => x === this.blockSite);
      if (webData) {
        this.recordExist = this.translate.instant('SETTINGS.BLOCKEURLEXISTWARNING');
      } else if (allowedWebData) {
        this.recordExist = this.translate.instant('SETTINGS.EXCLUDEURLALREADYADDED');
      } else {
        this.blockParticularWebList.push(this.blockSite);
        this.isParentalControlWebDirty = true; // Set dirty flag
      }
      this.blockSite = '';
      return true;
    }
  }

  deleteSelectedIndex(item: any) {
    this.recordExist = null;
    let index = this.blockParticularWebList.indexOf(item);
    this.blockParticularWebList.splice(index, 1);
    this.parentalControlForm.markAsDirty();
  }

  deleteSelectedExcludedIndex(item: any) {
    this.recordExist = null;
    let index = this.websiteList.indexOf(item);
    this.websiteList.splice(index, 1);
    this.parentalControlForm.markAsDirty();
  }

  ExcludeWebsite: any;
  addExcludeWebSiteUrl() {
    this.recordExistForExcludedWebsite = null;
    const regex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^\s]*)?$/;
    if (!regex.test(this.ExcludeWebsite)) {
      this._toastr.error(
        this.translate.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL")
      );
      return false;
    } else {
      const webData = this.websiteList.find((x: any) => x === this.ExcludeWebsite);
      const blockedWebData = this.blockParticularWebList.find((x: any) => x === this.ExcludeWebsite);
      if (webData) {
        this.recordExistForExcludedWebsite = this.translate.instant('SETTINGS.BLOCKEURLEXISTWARNING');
      } else if (blockedWebData) {
        this.recordExistForExcludedWebsite = this.translate.instant('SETTINGS.BLOCCKEDURLALREADYADDED');
      } else {
        this.websiteList.push(this.ExcludeWebsite);
        this.isParentalControlWebDirty = true; // Set dirty flag
      }
      this.ExcludeWebsite = '';
      return true;
    }
  }

  restoreDefault() {
    this.isLoading = true;

    const data = {
      deviceId: this.deviceId,
      restoreSettingType: this.selctedTabType,
    };

    this._service
      .putService(this._service.API_URL.restoreDefault, data)
      .subscribe({
        next: (response) => {
          this.isLoading = false;

          if (response && response.status.code === 200) {
            this._toastr.success('', response.status.message);
            $('#restorePopup').modal('hide');

            if (this.selctedTabType === 'smartParent') {
              setTimeout(() => {
                this.getSmartParentingSetttingsByDeviceId(this.deviceId);
                // this.getBrowserControlData();
              }, 0);
            }
          } else {
            this._toastr.error('', response.status.message);
          }
        },
        error: (error) => {
          this.isLoading = false;
          this._toastr.error(
            '',
            error?.error?.message || 'Something went wrong'
          );
        },
      });
  }

  // Blocked Channels
  addYtBlockedChannel() {
    this.ytBlockedChannelRecordExist = null;
    const val = this.ytBlockedChannelInput.trim();
    if (val && this.ytBlockedChannels.includes(val)) {
      this.ytBlockedChannelRecordExist = this.translate.instant('SETTINGS.BLOCKEDCHANNELEXISTWARNING');
    } else if (val && this.ytAllowedChannels.includes(val)) {
      this.ytBlockedChannelRecordExist = this.translate.instant('SETTINGS.YTBLOCKEDCHANNELALREADYADDEDERROR');
    } else {
      if (val) {
        this.ytBlockedChannels.push(val);
        this.isYtSupervisionDirty = true; // Set dirty flag
      } else {
        this.ytBlockedChannelRecordExist = this.translate.instant('SETTINGS.BLOCKCHANNELWARNING');
      }
      this.ytBlockedChannelInput = '';
    }
  }
  removeYtBlockedChannel(idx: number) {
    this.ytBlockedChannels.splice(idx, 1);
    this.isYtSupervisionDirty = true; // Set dirty flag
  }

  // Blocked Videos
  addYtBlockedVideo() {
    const val = (this.ytBlockedVideoInput || '').trim();
    this.ytBlockedVideoRecordExist = null;
    const regex =
      /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^\s]*)?$/;
    if (!regex.test(val)) {
      this._toastr.error(
        this.translate.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL")
      );
      return false;
    } else {
      this.ytBlockedVideoRecordExist = null;

      if (val && this.ytBlockedVideos.includes(val)) {
        this.ytBlockedVideoRecordExist = this.translate.instant(
          'SETTINGS.BLOCKEURLEXISTWARNING'
        );
      } else if (val && this.ytAllowedVideos.includes(val)) {
        this.ytBlockedVideoRecordExist = this.translate.instant(
          'SETTINGS.YTBLOCKEDVIDEOALREADYADDEDERROR'
        );
      } else {
        this.ytBlockedVideos.push(val);
        this.ytBlockedVideoInput = '';
        this.isYtSupervisionDirty = true;
      }
      return true;
    }
  }
  removeYtBlockedVideo(idx: number) {
    this.ytBlockedVideos.splice(idx, 1);
    this.isYtSupervisionDirty = true;
  }

  // Blocked Categories (select all, per category)
  toggleAllYtBlockedCategories(event: any) {
    this.ytBlockedCategories.forEach(
      (cat) => (cat.isChecked = event.target.checked)
    );
    this.isYtSupervisionDirty = true;
  }
  onYtCategoryCheckChange() {
    // Sync selectAll checkbox
    this.ytAllCategoriesChecked = this.ytBlockedCategories.every(
      (cat) => cat.isChecked
    );
    this.isYtSupervisionDirty = true;
  }

  // Blocked Keywords
  addYtBlockedKeyword() {
    this.ytBlockedKeywordRecordExist = null;
    const val = this.ytBlockedKeywordInput.trim();

    if (val && this.ytBlockedKeywords.includes(val)) {
      this.ytBlockedKeywordRecordExist = this.translate.instant(
        'SETTINGS.BLOCKEKEYWORDEXISTWARNING'
      );
    } else {
      if (val) {
        this.ytBlockedKeywords.push(val);
        this.isYtSupervisionDirty = true;
      } else {
        this.ytBlockedKeywordRecordExist = this.translate.instant(
          'SETTINGS.BLOCKEDENTERKEYWORDWARNING'
        );
      }
      this.ytBlockedKeywordInput = '';
    }
  }

  removeYtBlockedKeyword(idx: number) {
    this.ytBlockedKeywords.splice(idx, 1);
    this.isYtSupervisionDirty = true;
  }

  // Allowed Channels
  addYtAllowedChannel() {
    this.ytAllowedChannelRecordExist = null;
    const val = this.ytAllowedChannelInput.trim();
    if (val && this.ytAllowedChannels.includes(val)) {
      this.ytAllowedChannelRecordExist = this.translate.instant('SETTINGS.BLOCKEDCHANNELEXISTWARNING');
    } else if (val && this.ytBlockedChannels.includes(val)) {
      this.ytAllowedChannelRecordExist = this.translate.instant('SETTINGS.YTALLOWEDCHANNELALREADYADDEDERROR');
    } else {
      if (val) {
        this.ytAllowedChannels.push(val);
        this.isYtSupervisionDirty = true;
      } else {
        this.ytAllowedChannelRecordExist = this.translate.instant(
          'SETTINGS.ALLOWEDCHANNELNAMEWARNING'
        );
      }

      this.ytAllowedChannelInput = '';
    }
  }

  removeYtAllowedChannel(idx: number) {
    this.ytAllowedChannels.splice(idx, 1);
    this.isYtSupervisionDirty = true;
  }

  // Allowed Videos
  addYtAllowedVideo() {
    const val = (this.ytAllowedVideoInput || '').trim();

    this.ytAllowedVideoRecordExist = null;
    const regex =
      /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(?::\d+)?(\/[^\s]*)?$/;
    if (!regex.test(val)) {
      this._toastr.error(
        this.translate.instant("TOSTRMSGS.QH_TOSTR_ENTER_VALID_URL")
      );
      return false;
    } else {
      this.ytAllowedVideoRecordExist = null;

      if (val && this.ytAllowedVideos.includes(val)) {
        this.ytAllowedVideoRecordExist = this.translate.instant('SETTINGS.BLOCKEDCHANNELEXISTWARNING');
      } else if (val && this.ytBlockedVideos.includes(val)) {
        this.ytAllowedVideoRecordExist = this.translate.instant('SETTINGS.YTALLOWEDVIDEOALREADYADDEDERROR');
      } else {
        this.ytAllowedVideos.push(val);
        this.ytAllowedVideoInput = '';
        this.isYtSupervisionDirty = true;
      }
      return true;
    }
  }
  removeYtAllowedVideo(idx: number) {
    this.ytAllowedVideos.splice(idx, 1);
    this.isYtSupervisionDirty = true;
  }

  onFocusOut() {
    if (
      this.changePinForm.controls['pin'].value !==
      this.changePinForm.controls['confirmPin'].value
    ) {
      this.pinNotMatch = true;
      this.disableSave = false;
    } else {
      this.pinNotMatch = false;
    }
    this.changePinForm.markAsDirty;
  }

  submitChangePin(isApplySettings: boolean): Observable<number> {
    this.disableSave = false;
    this.changepindto = this.changePinForm.value;
    this.changepindto.pin = this.encryptService.encrypt(
      this.changePinForm.controls['pin'].value
    );
    this.changepindto.confirmPin = this.encryptService.encrypt(
      this.changePinForm.controls['confirmPin'].value
    );
    this.changepindto.deviceId = this.deviceId;
    this.changepindto.status = this.isDPinSettingOn ? '1' : '0';

    return this._service
      .postService(this._service.API_URL.changePin, this.changepindto)
      .pipe(
        map((response) => {
          this.isLoading = false;
          if (response && response.status.code === 200) {
            this.isLoading = false;
            this.changePinForm.markAsPristine;
            setTimeout(() => {
              this.changePinForm.markAsPristine();
            }, 0);
            if (!isApplySettings) {
              this._toastr.success('', response.status.message);
            }
            this.password = CommonEnums.password;
            this.passwords = CommonEnums.password;
            this.loginPin = false;
            this.confirmpin = false;
            return response.status.code;
          } else {
            this._toastr.error('', response.status.message);
          }
        })
      );
  }

  verifyPin() {
    if (
      this.changePinForm.controls['pin'].value?.length != 0 &&
      this.changePinForm.controls['pin'].value !==
      this.changePinForm.controls['confirmPin'].value
    ) {
      this.pinNotMatch = true;
    } else {
      this.pinNotMatch = false;
    }
  }

  onClick(val: string) {
    if (val == 'pin') {
      if (this.password === 'password') {
        this.password = CommonEnums.text;
        this.loginPin = true;
      } else {
        this.password = CommonEnums.password;
        this.loginPin = false;
      }
    } else if (val == 'confPin') {
      if (this.passwords === 'password') {
        this.passwords = CommonEnums.text;
        this.confirmpin = true;
      } else {
        this.passwords = CommonEnums.password;
        this.confirmpin = false;
      }
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.changePinForm.controls;
  }

  onFocusOutMobile(event: string, name: string) {
    this.validateNumbers();
    this.isAntiTheftDirty = true; // Set dirty flag
  }

  validateNumbers() {
    this.primaryMobileError = '';
    this.alternateMobileError = '';
    this.sameNumberError = '';
    this.disableSaveButton = false;

    // Trim inputs to handle accidental spaces
    const primary = (this.antiTheftPrimaryNumberInput || '').trim();
    const alternate = (this.antiTheftAlternateNumberInput || '').trim();

    // Check if anti-theft settings are enabled
    if (this.isAntiTheftSettingsOn) {
      // Primary number cannot be empty
      if (!primary || primary.length === 0 || primary === '') {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBERREQUIRED'
        );
        this.disableSaveButton = true;
      }

      // Primary number must be 10 digits
      if (primary.length > 0 && primary.length !== 10) {
        this.primaryMobileError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }

      // Alternate number, if provided, must be 10 digits
      if (alternate && alternate.length !== 10) {
        this.alternateMobileError = this.translate.instant(
          'SETTINGS.ALTERNATENUMBER10DIGITWARNING'
        );
        this.disableSaveButton = true;
      }

      // Primary and alternate numbers cannot be the same
      if (primary && alternate && primary === alternate) {
        this.sameNumberError = this.translate.instant(
          'SETTINGS.PRIMARYNUMBERWARNING'
        );
        this.disableSaveButton = true;
      }

      return;

    } else {
      // If anti-theft settings are off, no validation is needed
      this.disableSaveButton = false;
    }
  }


  keyPressAlphaNumericWithCharacters(event: any, name: string) {
    if (name === 'mobile') {
      let k = event.charCode || event.keyCode;
      return (
        (k >= 48 && k <= 57) || // 0-9
        k === 8 // Backspace
      );
    }
    return true;
  }

  removeSpace(event: any, name: string) {
    if (name === 'mobile' && event.code === 'Space') {
      event.preventDefault();
    }
  }

  checkPremiumFeature(deviceId: String) {
    let data: any[] = [];
    data = this.premiumRepInfo.filter((device: any) => device.id === deviceId);
    this.status = data[0]?.expiringStatus;
    this.licenseValidity = data[0]?.licenseValidityDate;
    this.showPremium =
      this.status != null || this.licenseValidity != null
        ? this.status === 'LICENSE_EXPIRED' || this.status === 'Free version'
        || this.licenseValidity === 'Free version' || this.licenseValidity === 'LICENSE_EXPIRED'
        : false;
    this.renewalLink = data[0]?.productLink;
    this.productKey = data[0]?.productKey;
    this.productKeyType = data[0]?.productType;
  }

  navigateToRenew() {
    if (this.productKeyType != 'MOBSEC_ADVANCE') {
      window.open(this.renewalLink + '?prdkey=' + this.productKey, '_blank');
    } else {
      $('#renewPopup').modal('show');
    }
  }


  getDeviceInUserTree() {
    this.isLoading = true;
    try {
      this._service.getService(this._service.API_URL.getDevicesInUser).subscribe((response: any) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this.otherDeviceFree = response.data.filter((data: any) => data.id != this.deviceId && (data?.isPremium || data?.isFreeVer));
          this.otherDevicePrem = response.data.filter((data: any) => data.id != this.deviceId && data?.isPremium);
          this.otherDevicePrem = this.otherDevicePrem.filter(device =>
            compareVersions(device.productVersion, this.mobileCompatibleVer) >= 0
          );
          this.otherDeviceFree = this.otherDeviceFree.filter(device =>
            compareVersions(device.productVersion, this.mobileCompatibleVer) >= 0
          );

        } else {
          this.isLoading = false;
        }
      })
    } catch (error) {
      this.isLoading = false;
    }
  }

  openupdatePopup() {
    $("#UpdateSettingsPopup").modal("show");
  }

  closeupdatepopUp() {
    $("#UpdateSettingsPopup").modal("hide");
  }

  openselectDevicePopup() {
    $("#UpdateSettingsPopup").modal("hide");
    if (this.requestType === 'SMART_PARENTING_SETTING' || this.requestType === 'YOUTUBE_SUPERVISION_SETTING' || this.requestType === 'ANTITHEFT_SETTING') {
      $("#selectDevicePopupPrem").modal("show");
    } else {
      $("#selectDevicePopupFree").modal("show");
    }

  }

  closeselectDevicepopUp() {
    $("#selectDevicePopupPrem").modal("hide");
    $("#selectDevicePopupFree").modal("hide");
  }

  openSuccessAppliedPopup() {
    $("#selectDevicePopupPrem").modal("hide");
    $("#selectDevicePopupFree").modal("hide");
    $("#SuccessAppliedModal").modal("show");
  }

  closeSuccessAppliedpopUp() {
    $("#SuccessAppliedModal").modal("hide");
  }

  onCheckboxChange(e: any) {
    const deviceArray: FormArray = this.deviceForm.get('deviceIds') as FormArray;

    if (e.target.checked) {
      deviceArray.push(this._formBuilder.control(e.target.value));
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }

    } else {
      const index = deviceArray.controls.findIndex(x => x.value === e.target.value);
      deviceArray.removeAt(index);
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }
    }
  }

  onCheckboxChangeFreePrompt(e: any) {
    const deviceArray: FormArray = this.deviceFormFree.get('deviceIds') as FormArray;

    if (e.target.checked) {
      deviceArray.push(this._formBuilder.control(e.target.value));
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }

    } else {
      const index = deviceArray.controls.findIndex(x => x.value === e.target.value);
      deviceArray.removeAt(index);
      if (deviceArray?.length > 0) {
        this.disableApply = true;
      }
      else {
        this.disableApply = false;
      }
    }
  }

  onApplySettingsToDevices() {

    try {
      this.otherDeviceSettings = new OtherDeviceSettings();
      this.otherDeviceSettings.deviceId = this.deviceId;
      if (this.requestType === 'SMART_PARENTING_SETTING' || this.requestType === 'YOUTUBE_SUPERVISION_SETTING' || this.requestType === 'ANTITHEFT_SETTING') {
        this.otherDeviceSettings.otherDevices = this.deviceForm.value?.deviceIds;
      } else {
        this.otherDeviceSettings.otherDevices = this.deviceFormFree.value?.deviceIds;
      }
      this.otherDeviceSettings.requestType = this.requestType;
      this.otherDeviceSettings.deviceType = CommonEnums.MOBILE;
      if (this.requestType === 'SMART_PARENTING_SETTING' || this.requestType === 'YOUTUBE_SUPERVISION_SETTING' || this.requestType === 'ANTITHEFT_SETTING') {
        this.selectedDevice = [];
        this.deviceForm.value?.deviceIds.forEach((deviceId: any) => {
          this.selectedDevice.push(this.otherDevicePrem.find(device => device.id == deviceId));
        })
      } else {
        this.selectedDevice = [];
        this.deviceFormFree.value?.deviceIds.forEach((deviceId: any) => {
          this.selectedDevice.push(this.otherDeviceFree.find(device => device.id == deviceId));
        })
      }

      //this.deviceForm.setControl('deviceIds', new FormArray([]));
      this._service.postService(this._service.API_URL.applySettingsToOtherDesktops, this.otherDeviceSettings).subscribe((response) => {
        if (response && response.status.code === 200) {
          this.isLoading = false;
          this._toastr.success('', response.status.message);
          this.openSuccessAppliedPopup();
        } else {
          this.isLoading = false;
          this._toastr.error('', response.status.message)
        }
      })
    } catch {
      this.isLoading = false;
    }
  }

  onResetCancel() {
    $("#resetSettingsModal").modal("hide");
  }

  onResetBtnClick() {
    $("#resetSettingsModal").modal("show");
  }

  private hasUnsavedChanges(): boolean {
    switch (this.selctedTabType) {
      case 'smartParent':
        return (
          this.parentalControlForm.dirty ||
          this.isParentalControlWebDirty ||
          this.isParentalControlAppDirty
        );
      case 'screenTime':
        // return !this.screentimeForm.dirty ? this.isScreenTimeDirty : false;
        if (this.screentimeForm.dirty) {
          return true;
        } else if (this.isScreenTimeDirty) {
          return true;
        } else {
          return false;
        }
      case 'YTSupervision':
        return this.isYtSupervisionDirty;
      case 'Theft':
        return this.isAntiTheftDirty;
      case 'DPin':
        return this.changePinForm.dirty;
      default:
        return false;
    }
  }

  // Method to reset dirty states after saving or discarding
  private resetDirtyStates(): void {
    this.parentalControlForm.markAsPristine();
    this.screentimeForm.markAsPristine();
    this.changePinForm.markAsPristine();
    this.isYtSupervisionDirty = false;
    this.isAntiTheftDirty = false;
    this.isParentalControlWebDirty = false;
    this.isParentalControlAppDirty = false;
    this.isScreenTimeDirty = false;
  }

  // Handle cancel action (stay on current tab or page)
  onUnsavedSettingsCancel() {
    $('#UnsavedSettingsPopup').modal('hide');
    $('#BackUnsavedSettingsPopup').modal('hide');
    this.pendingTabIndex = null;
    this.pendingTabType = null;
  }

  // Handle discard action (reset changes and proceed)
  onUnsavedSettingsDiscard() {
    // Reset forms and custom inputs to last saved state
    this.resetToLastSavedState();
    this.resetDirtyStates();

    // Close modals
    $('#UnsavedSettingsPopup').modal('hide');
    $('#BackUnsavedSettingsPopup').modal('hide');

    // Proceed with tab switch or navigation
    if (this.pendingTabIndex !== null && this.pendingTabType !== null) {
      this.getCurrentIndex = this.pendingTabIndex;
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.selectedI = this.pendingTabIndex;
      this.selctedTabType = this.pendingTabType; // Now type-safe
      this.handleTabSwitch(this.pendingTabType);
      this.pendingTabIndex = null;
      this.pendingTabType = null;
    } else {
      this.location.back();
    }
  }

  getLocalizationString(str: string): string {
    if (this.selectedLanguage === 'en' || !str) {
      return str;
    }

    const translationMap: { [key: string]: string } = {
      'Smart Parenting': 'SETTINGS.PARENTALCONTROL',
      'Screentime': 'SETTINGS.SCREENTIME',
      'Youtube Supervision': 'SETTINGS.YOUTUBESUPERVISION',
      'Theft & Intrusion Alert': 'MANAGEDEVICE.ANTITHEFTS',
      'Device Pin': 'MANAGEDEVICE.DEVICEPIN'
    };
    const key = translationMap[str];
    return key ? this.translate.instant(key) : str;
  }

  getLocalizationStringRole(str: String): String {
    if (this.selectedLanguage === 'en' || !str) {
      return str;
    }

    const translationMap: { [key: string]: string } = {
      'Super Admin': 'MANAGEUSER.ROLESADDNOTES.SUPERADMIN',
      'Admin': 'MANAGEUSER.ROLESADDNOTES.ADMIN',
      'Member': 'MANAGEUSER.ROLESADDNOTES.MEMBER',
      'Child': 'MANAGEUSER.ROLESADDNOTES.CHILD'
    };

    const key = translationMap[String(str)];
    return key ? this.translate.instant(key) : str;
  }

  // Reset forms and inputs to last saved state
  private resetToLastSavedState() {
    switch (this.selctedTabType) {
      case 'smartParent':
        this.getSmartParentingSetttingsByDeviceId(this.deviceId);
        break;
      case 'screenTime':
        this.getScreenTimeDataByDeviceId(this.deviceId);
        break;
      case 'YTSupervision':
        this.getBlockYoutubeSettingsByDeviceId(this.deviceId);
        break;
      case 'Theft':
        this.getDeviceAntiTheftSettingsByDeviceId(this.deviceId);
        break;
      case 'DPin':
        this.getDevicePinSettingsByDeviceId(this.deviceId);
        break;
    }
  }
}
